import { Breadcrumb, Button, Typography } from 'antd';

import { ArrowLeftOutlined } from '@ant-design/icons';
import { BreadcrumbItem } from '@core/interfaces';
import { Icon } from '@ant-design/compatible';
import { Link } from 'react-router-dom';
import { TranslateFn } from '@core/hooks/useTranslate';
import { useHistory } from 'react-router-dom';

interface Props {
  t: TranslateFn;
  title?: string;
  goBack?: boolean;
  breadcrumbList?: BreadcrumbItem[];
  extra?: React.ReactNode;
  titleDetail?: string;
  pageDetail?: string;
  url?: any;
}

const PageTop = ({
  t,
  titleDetail,
  pageDetail,
  title,
  breadcrumbList,
  extra,
  goBack = false,
  url
}: Props) => {
  const history = useHistory();
  return (
    <div className="page-top">
      {title === 'Dashboard' || 'Inquiry' ? null : (
        <Breadcrumb>
          {breadcrumbList?.map((item: any) => (
            <Breadcrumb.Item key={item}>
              {item.url ? (
                <Link to={item.url}>{t(item.label)}</Link>
              ) : (
                t(item.label)
              )}
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
      )}

      <Typography.Title
        level={4}
        className="page-top-title"
        style={{ display: 'flex', alignItems: 'center' }}
      >
        {goBack && (
          <Button
            style={{ border: 'none', background: '#fff' }}
            onClick={() => history.goBack()}
            icon={<ArrowLeftOutlined />}
          />
        )}
        {title}
        {titleDetail ? (
          <>
            {' '}
            <Icon type="right" />
            <Link to={url} style={{ color: '#747274', fontSize: '17px' }}>
              {titleDetail}
            </Link>
          </>
        ) : null}

        {pageDetail ? (
          <>
            {' '}
            <Icon type="right" />
            <span style={{ color: '#747274', fontSize: '17px' }}>
              {pageDetail}
            </span>
          </>
        ) : null}
      </Typography.Title>

      {extra}
    </div>
  );
};

export default PageTop;
